import React, { useState, useEffect, useMemo, useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import { ChartFontSelector, AddonAndSubPropetyBase } from "./ChatAddonPropety"
import { changeChartSetting } from "redux/ducks/Chart"
import ChartInputNumeric from "./ChartInputNumeric"
import ChartColorPicker from "./ChartColorPicker"
import _ from "lodash"

interface props {
  canvasId: string
  displayTitle: string
  targetGroup: string
  target: string
}

const VIEW_TYPY_1 = [
  "RSI_Scale1",
  "RSI_Scale2",
  "RSI_Scale3",
  "Stocast_Scale1",
  "Stocast_Scale2",
  "Stocast_Scale3",
  "MACD_L",
  "PsyCologic_Scale1",
  "PsyCologic_Scale2",
  "PsyCologic_Scale3",
  "AroonOsci_UpPeriod",
  "AroonOsci_DownPeriod",
  "Kairi3_Scale1",
  "Kairi3_Scale2",
  "Kairi3_Scale3",
  "RCI_Scale1",
  "RCI_Scale2",
  "RCI_Scale3",
  "DMI_dmi",
  "HinoharaRatio_Period",
  "Stocast_DS_K",
]

const VIEW_TYPY_2 = [
  "AroonOsci",
  "+DI",
  "-DI",
  "MarginBuying",
  "MarginSelling",
  "HinoharaRatio_RatioA",
  "HinoharaRatio_RatioB",
]

const VIEW_TYPY_3 = ["MACD_Osci", "Volume", "Spread1", "Spread2"]

const SubChartPropety = React.memo((props: props) => {
  const { canvasId, displayTitle, targetGroup, target } = props
  const dispatch = useDispatch()
  const termSelector = (state: any) => state.chart[canvasId].term
  const chartSettingSelector = (state: any) => state.chart.chartSetting
  const term = useSelector(termSelector)
  const chartSetting = useSelector(chartSettingSelector)
  const _param = useMemo(() => {
    return !_.get(
      chartSetting,
      ["sub", targetGroup, "_Def", target, term.key],
      null
    )
      ? ["sub", targetGroup, "_Def", target, "default"]
      : ["sub", targetGroup, "_Def", target, term.key]
  }, [term])
  const [visibleNumber, setVisibleNumber] = useState<number>()

  const _changeChartSetting = useCallback(
    (value: number, category: string, item: string, name: string) => {
      const _chartSetting = _.clone(chartSetting)
      _.set(_chartSetting, _param, value)
      dispatch(changeChartSetting(_chartSetting))
    },
    []
  )

  const checkTargetValue = () => {
    if (_.includes(VIEW_TYPY_1, target)) {
      setVisibleNumber(1)
    } else if (_.includes(VIEW_TYPY_2, target)) {
      setVisibleNumber(2)
    } else if (
      // + spread
      _.includes(VIEW_TYPY_3, target)
    ) {
      setVisibleNumber(3)
    } else if (target === "ADXModifier") {
      // 何も表示しない
      setVisibleNumber(4)
    } else {
      setVisibleNumber(0)
    }
  }

  useMemo(() => checkTargetValue(), [target])

  return (
    <>
      {visibleNumber === 0 && (
        <AddonAndSubPropetyBase
          chartType={"sub"}
          displayTitle={displayTitle}
          targetGroup={targetGroup}
          target={target}
          canvasId={canvasId}
          param={_param}
        />
      )}
      {visibleNumber === 1 && (
        <ChartInputNumeric
          mini={true}
          defaultValue={_.get(chartSetting, _param)}
          min={_.get(chartSetting, ["sub", targetGroup, "_Def", target, "min"])}
          max={_.get(chartSetting, ["sub", targetGroup, "_Def", target, "max"])}
          step={_.get(chartSetting, [
            "sub",
            targetGroup,
            "_Def",
            target,
            "step",
          ])}
          decimalDigits={_.get(chartSetting, [
            "sub",
            targetGroup,
            "_Def",
            target,
            "precision",
          ])}
          setValue={(value: number) => {
            _changeChartSetting(value, "sub", targetGroup, target)
          }}
        />
      )}
      {visibleNumber === 2 && (
        <div className="chart-setting">
          <ChartFontSelector
            chartType={"sub"}
            title={displayTitle}
            targetGroup={targetGroup}
            target={target}
            canvasId={canvasId}
          />
          <ChartColorPicker
            type={"sub"}
            targetGroup={targetGroup}
            target={target}
            parentId={"tech-setting"}
          />
        </div>
      )}
      {visibleNumber === 3 && (
        <ChartColorPicker
          type={"sub"}
          targetGroup={targetGroup}
          target={target}
          parentId={"tech-setting"}
        />
      )}
    </>
  )
})

export default SubChartPropety
